import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class UpdateClaimReadLocationDto {
  @Field(t => Int)
  claimId!: number

  @Field(t => Int)
  userId!: number

  @Field()
  cfi!: string
}
